(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-grouped"]) return;
  try {
    
  const url = new URL(window.location.href);

  const toHandle = (value) => {
    if (!value) {
      return '';
    }

    let text = decodeURIComponent(value);

    if (text.normalize) {
      text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, ''); 
    }

    return text
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  };

  const reorderGroups = (hashValue) => {
    const list = document.querySelector('#ResultsList .product-grid--{{ section.id }}');

    if (!list) {
      return;
    }

    const headings = Array.from(list.querySelectorAll('[data-group-role="heading"]'));

    if (!headings.length) {
      const fallbackId = hashValue ? decodeURIComponent(hashValue) : '';
      const fallbackEl = fallbackId ? document.getElementById(fallbackId) : null;

      if (fallbackEl) {
        fallbackEl.scrollIntoView({ behavior: 'instant', block: 'start' });
      }

      return;
    }

    const groups = headings.map((heading) => {
      const handle = heading.dataset.groupHandle;
      const items = [heading];
      let sibling = heading.nextElementSibling;

      while (
        sibling &&
        sibling.dataset &&
        sibling.dataset.groupHandle === handle &&
        sibling.dataset.groupRole !== 'heading'
      ) {
        items.push(sibling);
        sibling = sibling.nextElementSibling;
      }

      return { handle, items };
    });

    const normalizedHash = toHandle(hashValue);

    if (normalizedHash) {
      const targetIndex = groups.findIndex((group) => group.handle === normalizedHash);

      if (targetIndex > 0) {
        const [targetGroup] = groups.splice(targetIndex, 1);
        groups.unshift(targetGroup);

        const fragment = document.createDocumentFragment();

        groups.forEach((group) => {
          group.items.forEach((item) => {
            fragment.appendChild(item);
          });
        });

        list.appendChild(fragment);
      }
    }

    const fallbackId = hashValue ? decodeURIComponent(hashValue) : '';
    const scrollTarget =
      (normalizedHash &&
        list.querySelector(
          `[data-group-role="heading"][data-group-handle="${normalizedHash}"]`
        )) ||
      (fallbackId && document.getElementById(fallbackId));

    if (scrollTarget) {
      scrollTarget.scrollIntoView({ behavior: 'instant', block: 'start' });
    }
  };

  const initialHash = url.hash ? url.hash.slice(1) : '';

  document.addEventListener(
    'DOMContentLoaded',
    () => {
      if (initialHash) {
        reorderGroups(initialHash);
      }
    },
    { once: true }
  );

  window.addEventListener('hashchange', () => {
    reorderGroups(window.location.hash.slice(1));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-original"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded', 
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["team-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function copyToClipboard(text) {
      if (navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(text);
      }
      return new Promise(function (resolve, reject) {
        var textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        try {
          document.execCommand('copy');
          resolve();
        } catch (err) {
          reject(err);
        } finally {
          document.body.removeChild(textarea);
        }
      });
    }

    document.querySelectorAll('.team-gallery__item').forEach(function (item) {
      var trigger = item.querySelector('.team-gallery__image-wrap');
      var label = item.querySelector('.team-gallery__overlay-label');
      if (!trigger) return;

      trigger.addEventListener('click', function () {
        var email = item.dataset.email;
        if (!email) return;

        copyToClipboard(email).then(function () {
          item.classList.add('is-copied');
          if (label) label.textContent = label.dataset.copiedText || 'Copied!';

          if (item._tgTimeout) clearTimeout(item._tgTimeout);
          item._tgTimeout = setTimeout(function () {
            item.classList.remove('is-copied');
            if (label) label.textContent = label.dataset.defaultText || '';
          }, 2000);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
